export default __webpack_public_path__ + "static/media/profileBanner.f3b8938e.png";